import { createContext } from "react";

const LocaleContext = createContext<"USA" | "BRA">("BRA");

export default LocaleContext;
